import './ContactHome.css';
import igIcon from '../images/ig_50.png';
import mapImg from '../images/fusco_logo.png';


function ContactHome() {
  return (
    <section className="contact-map" id="contact">
      <div className="contact-map__inner">
        {/* Left: Contact details */}
        <div className="contact-pane">
          <h2 className="contact-title">Book Your Appointment Today</h2>
          <p className="contact-subheading">
            To request an appointment, please contact the phone number or email below and we will reach out to confirm your appointment as soon as we can.
            <i> <strong><br /><br />Mobile and in-shop appointments are accepted.</strong></i>
          </p>

          <div className="contact-block">
            <h4>Contact Info</h4>
            <p>Phone: <a href="tel:5187287466" className="contact-link">(518) 728-7466</a></p>
            <p>Email: <a href="mailto:fusco.matt@yahoo.com" className="contact-link">fusco.matt@yahoo.com</a></p>
          </div>


          <div className="contact-instagram">
            <a
              href="https://www.instagram.com/fusco_detailing"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-instagram"
              aria-label="Visit Fusco's Detailing on Instagram"
            >
              <img src={igIcon} alt="Instagram Icon" />
              <p className="follow-us">Follow us on Instagram</p>
            </a>
          </div>

        </div>

        {/* Right: Map placeholder */}
        <div className="map-pane" aria-label="Map preview">
          <img src={mapImg} alt="Map preview of 5 Test Drive, Town, NY 55555" />
        </div>
      </div>
    </section>
  )
}

export default ContactHome